var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.714,
    height: 16,
    fill: "#024EA2",
    viewBox: "0 0 13.714 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_173567",
    "data-name": "Group 173567",
    transform: "translate(371 952)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "align-box--middle-center",
    transform: "translate(-371 -952)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10931",
    "data-name": "Path 10931",
    d: "M16.571,18H5.143A1.144,1.144,0,0,1,4,16.857V3.143A1.144,1.144,0,0,1,5.143,2H16.571a1.144,1.144,0,0,1,1.143,1.143V16.857A1.144,1.144,0,0,1,16.571,18ZM5.143,3.143V16.857H16.571V3.143Z",
    transform: "translate(-4 -2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3007",
    "data-name": "Rectangle 3007",
    width: 8.457,
    height: 1.143,
    transform: "translate(11.086 6.171) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5649",
    "data-name": "Rectangle 5649",
    width: 6.857,
    height: 1.143,
    transform: "translate(10.286 8.571) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3008",
    "data-name": "Rectangle 3008",
    width: 4.571,
    height: 1.143,
    transform: "translate(9.143 10.971) rotate(180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIcon);
export default __webpack_public_path__ + "static/media/report_icon.cf35732fa92b3d5d87cc4c5e2137ce9d.svg";
export { ForwardRef as ReactComponent };